module.exports = __webpack_public_path__ + "img/bg_pop_signin.2b1f67e7.jpg";